import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let HipersensibleService = class HipersensibleService {
    constructor(http) {
        this.http = http;
        this.cargadoHipersensible = true;
        this.hipersensible = [];
        this.hipersensibleRFL = [];
        this.hipersensibleRFC = [];
        this.hipersensibleRFP = [];
        this.hipersensibleRCL = [];
        this.hipersensibleRCC = [];
        this.hipersensibleRCP = [];
        this.cargarHipersensible();
    }
    cargarHipersensible() {
        return new Promise((resolve, reject) => {
            this.http.get('assets/data/dataLineas.json')
                .subscribe((resp) => {
                this.hipersensible = resp;
                this.hipersensibleRFL = this.hipersensible[7].rutinafacial.limpieza;
                this.hipersensibleRFC = this.hipersensible[7].rutinafacial.cuidado;
                this.hipersensibleRFP = this.hipersensible[7].rutinafacial.proteccion;
                this.hipersensibleRCL = this.hipersensible[7].rutinacorporal.limpieza;
                this.hipersensibleRCC = this.hipersensible[7].rutinacorporal.cuidado;
                this.hipersensibleRCP = this.hipersensible[7].rutinacorporal.proteccion;
                setTimeout(() => {
                    this.cargadoHipersensible = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    }
};
HipersensibleService.ctorParameters = () => [
    { type: HttpClient }
];
HipersensibleService = tslib_1.__decorate([
    Injectable({
        providedIn: 'root'
    })
], HipersensibleService);
export { HipersensibleService };
//# sourceMappingURL=hipersensible.service.js.map